import { EM } from "msd-capacity-planning-model";
import env from "../app/Environment";
import fetchService from "../utils/FetchService";

export class EMService {
  constructor(private endpoint: string) {}

  async fetch(dateFilter?: string): Promise<EM[]> {
    const query = dateFilter
      ? `?dateFilter=${encodeURIComponent(dateFilter)}`
      : "";
    return fetchService
      .fetch(`${this.endpoint}/ems${query}`, {})
      .then((r) => r.json())
      .catch((): any[] => []);
  }

  async delete(id: string, dateFilter?: string): Promise<EM[]> {
    return fetchService
      .fetch(`${this.endpoint}/ems/${id}`, {
        method: "DELETE",
      })
      .then(() => this.fetch(dateFilter));
  }

  async persist(item: EM, dateFilter?: string): Promise<EM[]> {
    return fetchService
      .fetch(`${this.endpoint}/ems`, {
        method: "POST",
        body: JSON.stringify(item),
      })
      .then(() => this.fetch(dateFilter));
  }

  async setJiraAccess(id: string): Promise<void> {
    return fetchService
      .fetch(`${this.endpoint}/ems/${id}/jira/access`, {
        method: "POST",
      })
      .then(async (response) => {
        if (response.status && response.status !== 200) {
          throw new Error(`failed to grant Jira access`);
        }
      });
  }

  async setConfluenceAccess(id: string): Promise<void> {
    return fetchService
      .fetch(`${this.endpoint}/ems/${id}/confluence/access`, {
        method: "POST",
      })
      .then(async (response) => {
        if (response.status && response.status !== 200) {
          throw new Error(`failed to grant Confluence access`);
        }
      });
  }
}

const service: EMService = new EMService(env.endpoint);

export default service;
